import React from 'react'
import { withOrdersContainer, NoOrders, selectCampaign } from '../../normalizer';
import EmptyStateLayout from '../../shared/EmptyStateLayout';
import { withClientContainer, withBalanceContainer }  from "../../normalizer"


const InspectCard = ({Condition, setCondition, Selected}) =>{
  
  return (
    <div>
        <div style={{display:'flex', justifyContent:'space-between',alignItems:'center', margin:'10px auto', textAlign:'center', marginBottom:'15px'}}>
            <h4>Cartão: {Selected.number}</h4>
            <button className='primary-bg rounded font-quicksand navbar-text-white' style={{height:'40px', width:'200px', borderRadius:'10px'}} onClick={ event => setCondition(null)}> Voltar </button>
        </div>
        {Condition != null && <section className="w-full">
        <div className="overflow-x-auto">
          <table className={"mb-10 w-full"}>
            <thead className="text-color gl-profile__table">
              <tr className="gl-profile__info-row">
                <th className="p-3 whitespace-no-wrap text-left py-3">Encomenda</th>
                <th className="p-3 whitespace-no-wrap text-left">Carregado em</th>
                <th className="p-3 whitespace-no-wrap text-center">Estado</th>
                <th className="p-3 text-center">Valor Carregado</th>
              </tr>
            </thead>
            <tbody className="dead-grey">
              {Selected == null || Selected.recharges == null || Selected.recharges.length == 0 ? 
                <tr className="text-color gl-profile__info-row-hover"  >
                  <td className="p-4"> --- </td>
                  <td className="p-4 whitespace-no-wrap"> --- </td>
                  <td className='p-4 text-center'> --- </td>
                  <td className='p-4 text-center'> --- </td>
                </tr> 
              : Selected.recharges.map((value)=>(
                <tr className="text-color gl-profile__info-row-hover"  >
                  <td className="p-4"> {value.order.number} </td>
                  <td className="p-4 whitespace-no-wrap"> {value.requested_at} </td>
                  <td className="p-4 text-center"> {value.state.label} </td>

                  <td className='p-4 text-center'> {value.requested_value} </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>}
    </div>
  )
}

export default withBalanceContainer(InspectCard)
